const ReportsData = {

"Student Attendance": [
  {
    title: "Attendence Summary",
    description: "A completed record of student check in and check out times categorized by day and month",
    modalKey: "excelDynamicReport",
    config: {
      title: "Attendance Summary",
      lastGenerated: "22/05/2025 8:13 pm by Darshan",
      fields: [
        {
          label: "Date Range*",
          type: "dateRange",
          name: "dateRange"
        },
        {
          label: "Filter By",
          type: "radio",
          name: "filterBy",
          options: [
            { value: "classroom", label: "Classroom" },
            { value: "student", label: "Student" }
          ]
        },
        {
          label: "Select Room",
          name: "room",
          type: "dropdown",
          options: [{ value: "", label: "All Rooms" }],
          placeholder: "All Rooms"
        },
        {
          label: "Status",
          name: "status",
          type: "dropdown",
          options: [{ value: "", label: "select status of student" }],
          placeholder: "select status of student"
        }
      ]
    }
    
  },
  {
    title: "Absentees Report",
    description: "Get a report listing students who have not checked in for the selected day",
    modalKey: "excelDynamicReport",
    config: {
      title: "Absentees Report",
      lastGenerated: "22/05/2025 8:13 pm by Darshan",
      fields: [
        {
          label: "Date Range*",
          type: "dateRange",
          name: "dateRange"
        },
        {
          label: "Filter By",
          type: "radio",
          name: "filterBy",
          options: [
            { value: "classroom", label: "Classroom" },
            { value: "student", label: "Student" }
          ]
        },
        {
          label: "Select Room",
          name: "room",
          type: "dropdown",
          options: [{ value: "", label: "All Rooms" }],
          placeholder: "All Rooms"
        }
      ]
    }
    
  },
  {
    title: "Late Attendance",
    description: "A daily report showing students who checked in late compared to the scheduled start time",
    modalKey: "excelDynamicReport",
    config: {
      title: "Late Attendance",
      fields: [
        {
          label: "Date Range*",
          type: "dateRange",
          name: "dateRange"
        },
        {
          label: "Filter By",
          type: "radio",
          name: "filterBy",
          options: [
            { value: "classroom", label: "Classroom" },
            { value: "student", label: "Student" }
          ]
        },
        {
          label: "Select Room",
          name: "room",
          type: "dropdown",
          options: [{ value: "", label: "All Rooms" }],
          placeholder: "All Rooms"
        }
      ]
    }
    
  },
  {
    title: "Daily Time Card",
    description: "A detail report showing time spent by each student in each room, include check in and check out time.",
    modalKey: "excelDynamicReport",
    config: {
      title: "Daily Card Time",
      lastGenerated: "22/05/2025 8:13 pm by Darshan",
      fields: [
        {
          label: "Date Range*",
          type: "dateRange",
          name: "dateRange"
        },
        {
          label: "Filter By",
          type: "radio",
          name: "filterBy",
          options: [
            { value: "classroom", label: "Classroom" },
            { value: "student", label: "Student" }
          ]
        },
        {
          label: "Select Room",
          name: "room",
          type: "dropdown",
          options: [{ value: "", label: "All Rooms" }],
          placeholder: "All Rooms"
        }
      ]
    }
    
  },
  {
    title: "Monthly Attendance",
    description: "A summary of attendance and absence details for each student, categorized by month.",
    modalKey: "excelDynamicReport",
    config: {
      title: "Monthly Attendance",
      lastGenerated: "22/05/2025 8:13 pm by Darshan",
      fields: [
        {
          label: "Date Range*",
          type: "dateRange",
          name: "dateRange"
        },
        {
          label: "Filter By",
          type: "radio",
          name: "filterBy",
          options: [
            { value: "classroom", label: "Classroom" },
            { value: "student", label: "Student" }
          ]
        },
        {
          label: "Select Room",
          name: "room",
          type: "dropdown",
          options: [{ value: "", label: "All Rooms" }],
          placeholder: "All Rooms"
        }
      ]
    }
    
  },
  {
    title: "Weekly Attendance Report",
    description: "Weekly summary of student attendance for the selected class",
    modalKey: "excelDynamicReport",
    config: {
      title: "Weekly Attendance Report",
      fields: [
        {
          label: "Date Range*",
          type: "dateRange",
          name: "dateRange"
        },
        {
          label: "Filter By",
          type: "radio",
          name: "filterBy",
          options: [
            { value: "classroom", label: "Classroom" },
            { value: "student", label: "Student" }
          ]
        },
        {
          label: "Select Room",
          name: "room",
          type: "dropdown",
          options: [{ value: "", label: "All Rooms" }],
          placeholder: "All Rooms"
        }
      ],
      showAutoFill: true
    }
    
  },
  {
    title: "Pick And Deliver Sheets",
    description: "A printable sheet to track student pick-up and drop-off for transportation.",
    modalKey: "excelDynamicReport",
    config: {
      title: "pick and deliver sheet",
      fields: [
        {
          label: "Filter By",
          type: "radio",
          name: "filterBy",
          options: [
            { value: "classroom", label: "Classroom" },
            { value: "student", label: "Student" }
          ]
        },
        {
          label: "Select Room",
          name: "room",
          type: "dropdown",
          options: [{ value: "", label: "All Rooms" }],
          placeholder: "All Rooms"
        }
      ]
    }
    
  },
  {
    title: "Daily Schedule Reports",
    description: "Get a daily overview of all the student's schedules of a classroom",
    modalKey: "excelDynamicReport",
    config: {
      title: "Daily Schedule Report",
      fields: [
        {
          label: "Filter By",
          type: "radio",
          name: "filterBy",
          options: [
            { value: "classroom", label: "Classroom" },
            { value: "student", label: "Student" }
          ]
        },
        {
          label: "Select Room",
          name: "room",
          type: "dropdown",
          options: [{ value: "", label: "All Rooms" }],
          placeholder: "All Rooms"
        }
      ]
    }
    
  }
]
,
"Student Info": [
  {
    title: "Students  Report",
    
    description: "Download  report of students",
    modalKey: "excelDynamicReport",
    config: {
      title: "Student  Report",
      lastGenerated: "22/05/2025 8:13 pm by Darshan",
      fields: [
        {
          label: "Date Range*",
          type: "dateRange",
          name: "dateRange"
        },
        {
          label: "Filter By",
          type: "radio",
          name: "filterBy",
          options: [
            { value: "classroom", label: "Classroom" },
            { value: "student", label: "Student" }
          ]
        },
        {
          label: "Select Room",
          name: "room",
          type: "dropdown",
          options: [{ value: "", label: "All Rooms" }],
          placeholder: "All Rooms"
        },
        {
          label: "Status",
          name: "status",
          type: "dropdown",
          options: [{ value: "", label: "select status of student" }],
          placeholder: "select status of student"
        }
      ]
    }
  },
  {
    title: "Student Age Report",
    description: "Download birthday and age details of student",
    modalKey: "excelDynamicReport",
    config:{
      title: "Student age report",
      fields: [
        {
          label: "Filter By",
          type: "radio",
          name: "filterBy",
          options: [
            { value: "classroom", label: "Classroom" },
            { value: "student", label: "Student" }
          ]
        },
        {
          label: "Select Room",
          name: "room",
          type: "dropdown",
          options: [{ value: "", label: "All Rooms" }],
          placeholder: "All Rooms"
        }
      ]
    }
    
  },
  {
    title: "Students Notes",
    description: "Download student notes",
    modalKey: "excelDynamicReport",
    config: {
      title: "student notes",
      lastGenerated: "22/05/2025 8:13 pm by Darshan",
      fields: [
        {
          label: "Filter By",
          type: "radio",
          name: "filterBy",
          options: [
            { value: "classroom", label: "Classroom" },
            { value: "student", label: "Student" }
          ]
        },
        {
          label: "Select Room",
          name: "room",
          type: "dropdown",
          options: [{ value: "", label: "All Rooms" }],
          placeholder: "All Rooms"
        }
      ]
    }
    
  },
  {
    title: "Students Emergency Contacts",
    description: "Emergency contact details of students",
    modalKey: "excelDynamicReport",
    config: {
      title: "student emergency contact",
      lastGenerated: "22/05/2025 8:13 pm by Darshan",
      fields: [
        {
          label: "Filter By",
          type: "radio",
          name: "filterBy",
          options: [
            { value: "classroom", label: "Classroom" },
            { value: "student", label: "Student" }
          ]
        },
        {
          label: "Select Room",
          name: "room",
          type: "dropdown",
          options: [{ value: "", label: "All Rooms" }],
          placeholder: "All Rooms"
        }
      ]
    }
    
  },
  {
    title: "Student Count By Age Group",
    description: "Breakdown of student count based on age groups.",
    modalKey: "excelDynamicReport",
    config: {
      title: "student count by age group",
      lastGenerated: "22/05/2025 8:13 pm by Darshan",
      fields: [
        {
          label: "Date Range*",
          type: "dateRange",
          name: "dateRange"
        }
      ]
    }
    
  },
  {
    title: "Authorised Pickups",
    description: "List of students with authorized pickup guardians",
    modalKey: "excelDynamicReport",
    config:{
      title: "Authorised pickups",
      lastGenerated: "22/05/2025 8:13 pm by Darshan",
      fields: [
        {
          label: "Filter By",
          type: "radio",
          name: "filterBy",
          options: [
            { value: "classroom", label: "Classroom" },
            { value: "student", label: "Student" }
          ]
        },
        {
          label: "Select Room",
          name: "room",
          type: "dropdown",
          options: [{ value: "", label: "All Rooms" }],
          placeholder: "All Rooms"
        }
      ]
    }
    
  },
  {
    title: "Students Allergy Report",
    description: "Download complete student data",
    modalKey: "excelDynamicReport",
    config: {
      title: "Student allergy report",
      fields: [
        {
          label: "Filter By",
          type: "radio",
          name: "filterBy",
          options: [
            { value: "classroom", label: "Classroom" },
            { value: "student", label: "Student" }
          ]
        },
        {
          label: "Select Room",
          name: "room",
          type: "dropdown",
          options: [{ value: "", label: "All Rooms" }],
          placeholder: "All Rooms"
        }
      ]
    }
    
  },
  {
    title: "Student Information Sheet",
    description: "Snapshot of student details and emergency contacts.",
    modalKey: "excelDynamicReport",
    config: {
      title: "Student Information Sheet",
      fields: [
        {
          label: "Filter By",
          type: "radio",
          name: "filterBy",
          options: [{ value: "student", label: "Student" }]
        },
        {
          label: "Select student",
          name: "student",
          type: "dropdown",
          options: [{ value: "", label: "select student" }],
          placeholder: "select student"
        }
      ]
    }
  }
]
,
"Billing": [
  {
    heading: "Student Invoice Information",
    reports: [
      {
        title: "Student Balance",
        description: "View outstanding balances by student and filter by criteria.",
        modalKey: "excelDynamicReport",
        config: {
          title: "Student Balance",
          fields: [
            {
              type: "radio",
              name: "studentBalanceFilter",
              label: "Filter By",
              options: [{ value: "student", label: "Student" }]
            },
            {
              type: "dropdown",
              name: "student",
              label: "Select student",
              options: [{ value: "", label: "select student" }],
              placeholder: "select student"
            },
            {
              type: "dropdown",
              name: "reportFilter",
              label: "Report Filter",
              options: [{ value: "zero", label: "show students with zero balance" }],
              placeholder: "show students with zero balance"
            },
            {
              type: "dropdown",
              name: "invoiceStatus",
              label: "show invoice status",
              options: [{ value: "overdue", label: "show only overdue invoices" }],
              placeholder: "show only overdue invoices"
            }
          ]
        }
      }
      ,   
      {
        title: "Student invoices",
        description: "Generate invoice report for students over a given period.",
        modalKey: "excelDynamicReport",
        config: {
          title: "Student invoices",
          lastGenerated: "22/05/2025 8:13 pm .By Darshan",
          fields: [
            {
              type: "dateRange",
              label: "Date Range*"
            },
            {
              type: "radio",
              name: "invoiceFilter",
              label: "Filter By",
              options: [
                { value: "classroom", label: "Classroom" }
              ]
            },
            {
              type: "dropdown",
              name: "room",
              label: "Select Room",
              options: [{ value: "all", label: "All Rooms" }],
              placeholder: "All Rooms"
            },
            {
              type: "dropdown",
              name: "format",
              label: "Select format",
              options: [
                { value: "pdf", label: "PDF" },
                { value: "excel", label: "Excel" }
              ],
              placeholder: "select format"
            },
            {
              type: "radio",
              name: "invoiceType",
              label: "",
              options: [
                { value: "invoice", label: "Invoice" },
                { value: "billingPeriod", label: "Billing Period" }
              ]
            }
          ]
        }
      }
      
      ,
      {
        title: "Fee Plan",
        description: "View fee plans filtered by classroom or student.",
        modalKey: "excelDynamicReport",
        config: {
          title: "Fee Plan",
          fields: [
            {
              type: "radio",
              name: "feeFilter",
              label: "Filter By",
              options: [
                { value: "classroom", label: "Classroom" },
                { value: "student", label: "Student" }
              ]
            },
            {
              type: "dropdown",
              name: "room",
              label: "Select Room",
              options: [{ value: "all", label: "All Rooms" }],
              placeholder: "All Rooms"
            }
          ]
        }
      }
      
      ,
      {
        title: "Line Item",
        description: "Get detailed breakdown of invoices by line-item for date range.",
        modalKey: "excelDynamicReport",
        config: {
          title: "Line Item",
          lastGenerated: "22/05/2025 8:13 pm .By Darshan",
          showAutoFill: false,
          fields: [
            {
              type: "dateRange",
              label: "Date Range*"
            },
            {
              type: "radio",
              name: "lineItemFilter",
              label: "Filter By",
              options: [
                { value: "classroom", label: "Classroom" },
                { value: "student", label: "Student" }
              ]
            },
            {
              type: "dropdown",
              name: "room",
              label: "Select Room",
              options: [{ value: "all", label: "All Rooms" }],
              placeholder: "All Rooms"
            },
            {
              type: "radio",
              name: "lineItemDateType",
              label: "", // No label as per design
              options: [
                { value: "invoiceDate", label: "invoice date" },
                { value: "billingDate", label: "Billing date" }
              ]
            },
            {
              type: "dropdown",
              name: "status",
              label: "Status",
              options: [{ value: "", label: "select status of student" }],
              placeholder: "select status of student"
            }
          ]
        }
      }
      
      
      
      ,
      {
        title: "monthly charges report",
        description: "View monthly charges applied to students over a selected period.",
        modalKey: "excelDynamicReport",
        config: {
          title: "monthly charges report",
          fields: [
            {
              type: "dateRange",
              label: "Date Range*"
            },
            {
              type: "dropdown",
              label: "Status",
              name: "status",
              options: [{ value: "", label: "select status of student" }],
              placeholder: "select status of student"
            }
          ]
        }
      }
      
      ,
      {
        title: "Credit note report",
        description: "Get report of all issued credit notes within a specific date range.",
        modalKey: "excelDynamicReport",
        config: {
          title: "Credit note report",
          fields: [
            {
              type: "dateRange",
              label: "Date Range*",
              name: "creditNoteDateRange"
            }
          ]
        }
      }
      
      ,
    ],
  },
  {
    heading: "Payments And Deposits",
    reports: [
      {
        title: "payment report",
        description: "Generate report for student payments filtered by room and format.",
        modalKey: "excelDynamicReport",
        config: {
          title: "payment report",
          fields: [
            {
              type: "dateRange",
              label: "Date Range*",
              name: "paymentDateRange"
            },
            {
              type: "radio",
              label: "Filter By",
              name: "filterBy",
              options: [
                { label: "Classroom", value: "classroom" }
              ]
            },
            {
              type: "dropdown",
              label: "Select Room",
              name: "room",
              placeholder: "All Rooms",
              options: [
                { label: "All Rooms", value: "" }
              ]
            },
            {
              type: "dropdown",
              label: "Select format",
              name: "format",
              placeholder: "select format",
              options: [
                { label: "select format", value: "" }
              ]
            }
          ]
        }
      }
      ,
      {
        title: "Deposit History",
        description: "View deposit history filtered by classroom or student.",
        modalKey: "excelDynamicReport",
        config: {
          title: "Deposit History",
          fields: [
            {
              type: "radio",
              label: "Filter By",
              name: "filterBy",
              options: [
                { label: "Classroom", value: "classroom" },
                { label: "Student", value: "student" }
              ]
            },
            {
              type: "dropdown",
              label: "Select Room",
              name: "room",
              placeholder: "All Rooms",
              options: [
                { label: "All Rooms", value: "" }
              ]
            }
          ]
        }
      }
      ,
      {
        title: "Credit history",
        description: "View credit history filtered by classroom or student.",
        modalKey: "excelDynamicReport",
        config: {
          title: "Credit history",
          fields: [
            {
              type: "radio",
              label: "Filter By",
              name: "filterBy",
              options: [
                { label: "Classroom", value: "classroom" },
                { label: "Student", value: "student" }
              ]
            },
            {
              type: "dropdown",
              label: "Select Room",
              name: "room",
              placeholder: "All Rooms",
              options: [
                { label: "All Rooms", value: "" }
              ]
            }
          ]
        }
      }
      ,
      {
        title: "Deposit report",
        description: "Generate a report of all deposits made within a selected date range.",
        modalKey: "excelDynamicReport",
        config: {
          title: "Deposit report",
          fields: [
            {
              type: "dateRange",
              label: "Date Range*",
              name: "depositDateRange"
            }
          ]
        }
      }
      ,
      {
        title: "Detailed deposit History",
        description: "View detailed deposit history for a selected date range and room.",
        modalKey: "excelDynamicReport",
        config: {
          title: "Detailed deposit History",
          fields: [
            {
              type: "dateRange",
              label: "Date Range*",
              name: "detailedDepositDateRange"
            },
            {
              type: "dropdown",
              label: "Select Room",
              name: "room",
              placeholder: "All Rooms",
              options: [
                { label: "All Rooms", value: "" }
              ]
            }
          ]
        }
      }
      ,
      {
        title: "Discount Report",
        description: "Generate a report of all discounts applied within a selected date range and room.",
        modalKey: "excelDynamicReport",
        config: {
          title: "Discount Report",
          fields: [
            {
              type: "dateRange",
              label: "Date Range*",
              name: "discountDateRange"
            },
            {
              type: "dropdown",
              label: "Select Room",
              name: "room",
              placeholder: "All Rooms",
              options: [
                { label: "All Rooms", value: "" }
              ]
            }
          ]
        }
      }
      ,
      {
        title: "Refund listing report",
        description: "Generate a listing of all refunds filtered by date and discount type.",
        modalKey: "excelDynamicReport",
        config: {
          title: "Refund listing report",
          fields: [
            {
              type: "dateRange",
              label: "Date Range*",
              name: "refundDateRange"
            },
            {
              type: "dropdown",
              label: "Discount",
              name: "discount",
              placeholder: "Leave empty for all discount",
              options: [
                { label: "Leave empty for all discount", value: "" }
              ]
            }
          ]
        }
      }
      ,
      {
        title: "Daily collection summary",
        description: "View a summary of all collections as of a specific date.",
        modalKey: "excelDynamicReport",
        config: {
          title: "Daily collection summary",
          fields: [
            {
              type: "date",
              label: "As of date",
              name: "asOfDate",
              dateType: "single"
            }
          ]
        }
      }
      
      ,
    ],
  },
  {
    heading: "Aging, Compliance & Specialized Reports",
    reports: [
      {
        title: "Expense report",
        description: "View a report of all expenses within a selected date range.",
        modalKey: "excelDynamicReport",
        config: {
          title: "Expense report",
          fields: [
            {
              type: "dateRange",
              label: "Date Range*",
              name: "expenseDateRange"
            }
          ]
        }
      }
      ,
      {
        title: "monthly aging report",
        description: "View aging of invoices for a selected date range and specific date snapshot.",
        modalKey: "excelDynamicReport",
        config: {
          title: "monthly aging report",
          fields: [
            {
              type: "dateRange",
              label: "Date Range*",
              name: "agingDateRange"
            },
            {
              type: "date",
              label: "As of date",
              name: "asOfDate",
              dateType: "single"
            }
          ]
        }
      }
      ,
      {
        title: "Invoice Ageing Report",
        description: "Generate a report showing overdue invoices filtered by classroom or student.",
        modalKey: "excelDynamicReport",
        config: {
          title: "Invoice Ageing Report",
          fields: [
            {
              type: "radio",
              label: "Filter By",
              name: "filterBy",
              options: [
                { label: "Classroom", value: "classroom" },
                { label: "Student", value: "student" }
              ]
            },
            {
              type: "dropdown",
              label: "Select Room",
              name: "room",
              placeholder: "All Rooms",
              options: [
                { label: "All Rooms", value: "" }
              ]
            },
            {
              type: "dropdown",
              label: "Invoice Status",
              name: "invoiceStatus",
              placeholder: "Show Only Overdue Invoices",
              options: [
                { label: "Show Only Overdue Invoices", value: "overdue" }
              ]
            }
          ]
        }
      }
      ,
    ],
  },
  {
    heading: "Subsidy Reports",
    reports: [
      {
        title: "Subsidy Collection",
        description: "Generate a subsidy collection report filtered by date and classroom.",
        modalKey: "excelDynamicReport",
        config: {
          title: "Subsidy Collection",
          fields: [
            {
              type: "dateRange",
              label: "Date Range*",
              name: "subsidyDateRange"
            },
            {
              type: "radio",
              label: "Filter By",
              name: "filterBy",
              options: [
                { label: "Classroom", value: "classroom" }
              ]
            },
            {
              type: "dropdown",
              label: "Select Room",
              name: "room",
              placeholder: "All Rooms",
              options: [
                { label: "All Rooms", value: "" }
              ]
            }
          ]
        }
      }
      ,
      {
        title: "Subsidy Usage",
        description: "Generate a report of subsidy usage filtered by date and classroom.",
        modalKey: "excelDynamicReport",
        config: {
          title: "Subsidy Usage",
          fields: [
            {
              type: "dateRange",
              label: "Date Range*",
              name: "subsidyUsageDateRange"
            },
            {
              type: "radio",
              label: "Filter By",
              name: "filterBy",
              options: [
                { label: "Classroom", value: "classroom" }
              ]
            },
            {
              type: "dropdown",
              label: "Select Room",
              name: "room",
              placeholder: "All Rooms",
              options: [
                { label: "All Rooms", value: "" }
              ]
            }
          ]
        }
      }
      ,
    ],
  },
],
"Staff": [
    {
      heading: "Staff Data",
      reports: [
        {
          title: "Staff Report",
          description: "View staff-related report based on classroom, room, and student status.",
          modalKey: "excelDynamicReport",
          config: {
            title: "Staff Report",
            lastGenerated: "22/05/2025 8:13 pm .By Darshan",
            fields: [
              {
                type: "dateRange",
                label: "Date Range*",
                name: "staffReportDateRange"
              },
              {
                type: "radio",
                label: "Filter By",
                name: "filterBy",
                options: [
                  { label: "Classroom", value: "classroom" }
                ]
              },
              {
                type: "dropdown",
                label: "Select Room",
                name: "room",
                placeholder: "All Rooms",
                options: [
                  { label: "All Rooms", value: "" }
                ]
              },
              {
                type: "dropdown",
                label: "Select Status",
                name: "status",
                placeholder: "select Status of Student",
                options: [
                  { label: "select Status of Student", value: "" }
                ]
              }
            ]
          }
        }
        
      ]
    },
    {
      heading: "Staff Attendance",
      reports: [
        {
          title: "Attendance Summary",
          description: "View attendance summary based on classroom or student filter.",
          modalKey: "excelDynamicReport",
          config: {
            title: "Attendance Summary",
            lastGenerated: "22/05/2025 8:13 pm .By Darshan",
            fields: [
              {
                type: "dateRange",
                label: "Date Range*",
                name: "attendanceDateRange"
              },
              {
                type: "radio",
                label: "Filter By",
                name: "filterBy",
                options: [
                  { label: "Classroom", value: "classroom" },
                  { label: "Student", value: "student" }
                ]
              },
              {
                type: "dropdown",
                label: "Select Room",
                name: "room",
                placeholder: "All Rooms",
                options: [
                  { label: "All Rooms", value: "" }
                ]
              },
              {
                type: "dropdown",
                label: "Status",
                name: "status",
                placeholder: "select status of student",
                options: [
                  { label: "select status of student", value: "" }
                ]
              }
            ]
          }
        }
        ,
        {
          title: "Absentees Report",
          description: "Generate a report of absentees filtered by date range and room.",
          modalKey: "excelDynamicReport",
          config: {
            title: "Absentees Report",
            fields: [
              {
                type: "dateRange",
                label: "Date Range*",
                name: "absenteesDateRange"
              },
              {
                type: "radio",
                label: "Filter By",
                name: "filterBy",
                options: [
                  { label: "Classroom", value: "classroom" },
                  { label: "Student", value: "student" }
                ]
              },
              {
                type: "dropdown",
                label: "Select Room",
                name: "room",
                placeholder: "All Rooms",
                options: [
                  { label: "All Rooms", value: "" }
                ]
              }
            ]
          }
        }
        ,
        {
          title: "Late Attendance",
          description: "Generate a report of late attendances filtered by date range and room.",
          modalKey: "excelDynamicReport",
          config: {
            title: "Late Attendance",
            fields: [
              {
                type: "dateRange",
                label: "Date Range*",
                name: "lateAttendanceDateRange"
              },
              {
                type: "radio",
                label: "Filter By",
                name: "filterBy",
                options: [
                  { label: "Classroom", value: "classroom" },
                  { label: "Student", value: "student" }
                ]
              },
              {
                type: "dropdown",
                label: "Select Room",
                name: "room",
                placeholder: "All Rooms",
                options: [
                  { label: "All Rooms", value: "" }
                ]
              }
            ]
          }
        }
        ,
        {
          title: "Monthly Attendance",
          description: "Generate a monthly attendance report filtered by date range and room.",
          modalKey: "excelDynamicReport",
          config: {
            title: "Monthly Attendance",
            fields: [
              {
                type: "dateRange",
                label: "Date Range*",
                name: "monthlyAttendanceDateRange"
              },
              {
                type: "radio",
                label: "Filter By",
                name: "filterBy",
                options: [
                  { label: "Classroom", value: "classroom" },
                  { label: "Student", value: "student" }
                ]
              },
              {
                type: "dropdown",
                label: "Select Room",
                name: "room",
                placeholder: "All Rooms",
                options: [
                  { label: "All Rooms", value: "" }
                ]
              }
            ]
          }
        }
        ,
        {
          title: "Daily Time Card",
          description: "Generate a daily time card report filtered by date range and room.",
          modalKey: "excelDynamicReport",
          config: {
            title: "Daily Time Card",
            fields: [
              {
                type: "dateRange",
                label: "Date Range*",
                name: "dailyTimeCardDateRange"
              },
              {
                type: "radio",
                label: "Filter By",
                name: "filterBy",
                options: [
                  { label: "Classroom", value: "classroom" },
                  { label: "Student", value: "student" }
                ]
              },
              {
                type: "dropdown",
                label: "Select Room",
                name: "room",
                placeholder: "All Rooms",
                options: [
                  { label: "All Rooms", value: "" }
                ]
              }
            ]
          }
        }
        
      ]
    }
  ],
"Enquiry": [
  {
    heading: "Enquiry",
    reports: [
      {
        title: "Enquiry Report",
        description: "Get leads data and complete report",
        modalKey: "excelDynamicReport",
        config: {
          title: "Enquiry Report",
          lastGenerated: "22/05/2025 8:13 pm .By Darshan",
          fields: [
            {
              type: "dateRange",
              label: "Date Range*",
              name: "enquiryDateRange"
            },
            {
              type: "dropdown",
              label: "Status",
              name: "status",
              placeholder: "select status of student",
              options: [
                { label: "select status of student", value: "" }
              ]
            }
          ]
        }
      }
      ,
      {
        title: "Enquiry Active Report",
        description: "Get leads activity report",
        modalKey: "excelDynamicReport",
        config: {
          title: "Enquiry Active Report",
          fields: [
            {
              type: "dateRange",
              label: "Date Range*",
              name: "enquiryActiveDateRange"
            }
          ]
        }
      }
      ,
      {
        title: "Enquiry Count By Stage",
        description: "Access leads count information at each stage of the enrollment pipeline.",
        modalKey: "excelDynamicReport",
        config: {
          title: "Enquiry Count By Stage",
          fields: [
            {
              type: "dateRange",
              label: "Date Range*",
              name: "enquiryCountStageDateRange"
            }
          ]
        }
      }
      ,
      {
        title: "Enquiry Lost Reason Report",
        description: "Get an overview of all lost leads and their reasons.",
        modalKey: "excelDynamicReport",
        config: {
          title: "Enquiry Lost Reason Report",
          fields: [
            {
              type: "dateRange",
              label: "Date Range*",
              name: "enquiryLostReasonDateRange"
            }
          ]
        }
      }
      ,
      {
        title: "Weekly Enquiry Change",
        description: "This report displays the variation in the number of weekly leads.",
        modalKey: "excelDynamicReport",
        config: {
          title: "Weekly Enquiry Change",
          fields: []
        }
      }
      ,
      {
        title: "Cumulative Enquiry By Stages",
        description: "This report provides an ongoing count of leads at each stage in the pipeline.",
        modalKey: "excelDynamicReport",
        config: {
          title: "Cumulative Enquiry By Stages",
          fields: [
            {
              type: "dateRange",
              label: "Date Range*",
              name: "cumulativeStageDateRange"
            },
            {
              type: "dropdown",
              label: "Status",
              name: "status",
              placeholder: "select status of student",
              options: [
                { label: "select status of student", value: "" }
              ]
            }
          ]
        }
      }
      ,
      {
        title: "Source Awareness Report",
        description: "This report displays the count of leads generated from each marketing source channel.",
        modalKey: "excelDynamicReport",
        config: {
          title: "Source Awareness Report",
          fields: [
            {
              type: "dateRange",
              label: "Date Range*",
              name: "sourceAwarenessDateRange"
            }
          ]
        }
      }
      
    ]
  },
  {
    heading: "Tour Management",
    reports: [
      {
        title: "Appointment Report",
        description: "View appointment-related data within a selected date range.",
        modalKey: "excelDynamicReport",
        config: {
          title: "Appointment Report",
          fields: [
            {
              type: "dateRange",
              label: "Date Range*",
              name: "appointmentDateRange"
            }
          ]
        }
      }
      
    ]
  }
],
"Admissions": [
  {
    heading: "Programs",
    reports: [
      {
        title: "Program students Report",
        description: "Download student profile metadata and the associated program details",
        modalKey: "excelDynamicReport",
        config: {
          title: "Program students Report",
          fields: [
            {
              type: "dateRange",
              label: "Date Range*",
              name: "programStudentsDateRange"
            },
            {
              type: "radio",
              label: "Filter By",
              name: "filterBy",
              options: [{ label: "Classroom", value: "classroom" }]
            },
            {
              type: "dropdown",
              label: "Select Room",
              name: "room",
              placeholder: "All Rooms",
              options: [{ label: "All Rooms", value: "" }]
            },
            {
              type: "dropdown",
              label: "Select Status",
              name: "status",
              placeholder: "select status of Student",
              options: [{ label: "select status of Student", value: "" }]
            }
          ]
        }
      }
      ,
      {
        title: "Programs Report",
        description: "Download program related information",
        modalKey: "excelDynamicReport",
        config: {
          title: "Programs Report",
          fields: [
            {
              type: "dateRange",
              label: "Date Range*",
              name: "programsDateRange"
            },
            {
              type: "radio",
              label: "Filter By",
              name: "filterBy",
              options: [{ label: "Classroom", value: "classroom" }]
            },
            {
              type: "dropdown",
              label: "Select Room",
              name: "room",
              placeholder: "All Rooms",
              options: [{ label: "All Rooms", value: "" }]
            }
          ]
        }
      }
      ,
      {
        title: "Defered List Report",
        description: "Download defered list related information",
        modalKey: "excelDynamicReport",
        config: {
          title: "Defered List Report",
          fields: [
            {
              type: "dateRange",
              label: "Date Range*",
              name: "deferedListDateRange"
            },
            {
              type: "radio",
              label: "Filter By",
              name: "filterBy",
              options: [{ label: "Classroom", value: "classroom" }]
            },
            {
              type: "dropdown",
              label: "Select Room",
              name: "room",
              placeholder: "All Rooms",
              options: [{ label: "All Rooms", value: "" }]
            }
          ]
        }
      }
      ,
      {
        title: "Transfer Campus List With Programs",
        description: "This report lists student transfers between campuses along with the associated programs.",
        modalKey: "excelDynamicReport",
        config: {
          title: "Transfer Campus List With Programs",
          fields: [
            {
              type: "dateRange",
              label: "Date Range*",
              name: "transferCampusProgramsDateRange"
            },
            {
              type: "radio",
              label: "Filter By",
              name: "filterBy",
              options: [{ label: "Classroom", value: "classroom" }]
            },
            {
              type: "dropdown",
              label: "Select Room",
              name: "room",
              placeholder: "All Rooms",
              options: [{ label: "All Rooms", value: "" }]
            }
          ]
        }
      }
      ,
      {
        title: "New Joiner Breakdown By Month",
        description: "Get a breakdown of new student enrollments every month for tracking admission trends.",
        modalKey: "excelDynamicReport",
        config: {
          title: "New Joiner Breakdown By Month",
          fields: [
            {
              type: "dateRange",
              label: "Date Range*",
              name: "newJoinerBreakdownDateRange"
            }
          ]
        }
      }
      ,
    ]
  },
  {
    heading: "Tour Management",
    reports: [
      {
        title: "Active Students Report",
        description: "Download complete data of active students within a date range",
        modalKey: "excelDynamicReport",
        config: {
          title: "Active Students Report",
          fields: [
            {
              type: "dateRange",
              label: "Date Range*",
              name: "activeStudentsDateRange"
            },
            {
              type: "radio",
              label: "Filter By",
              name: "filterBy",
              options: [
                { label: "Classroom", value: "classroom" }
              ]
            },
            {
              type: "dropdown",
              label: "Select Room",
              name: "room",
              placeholder: "All Rooms",
              options: [
                { label: "All Rooms", value: "" }
              ]
            }
          ]
        }
      }
      ,
      {
        title: "Student Status Report",
        description: "Access comprehensive list of all students with their current enrollment status and program details in this report.",
        modalKey: "excelDynamicReport",
        config: {
          title: "Student Status Report",
          fields: [
            {
              type: "dateRange",
              label: "Date Range*",
              name: "studentStatusDateRange"
            },
            {
              type: "radio",
              label: "Filter By",
              name: "filterBy",
              options: [
                { label: "Classroom", value: "classroom" }
              ]
            },
            {
              type: "dropdown",
              label: "Select Status",
              name: "status",
              placeholder: "Select Status",
              options: [
                { label: "Select Status", value: "" }
              ]
            }
          ]
        }
      }
      ,
      {
        title: "Transfer Campus List Report",
        description: "Gives detail of students transferred details summarised at month level.",
        modalKey: "excelDynamicReport",
        config: {
          title: "Transfer Campus List Report",
          fields: [
            {
              type: "dateRange",
              label: "Date Range*",
              name: "transferCampusDateRange"
            },
            {
              type: "radio",
              label: "Filter By",
              name: "filterBy",
              options: [
                { label: "Classroom", value: "classroom" }
              ]
            },
            {
              type: "dropdown",
              label: "Select Room",
              name: "room",
              placeholder: "All Rooms",
              options: [
                { label: "All Rooms", value: "" }
              ]
            }
          ]
        }
      }
      ,
      {
        title: "Withdrawal Report",
        description: "Get detailed summary of all students who have withdrawn their admission, for efficient tracking.",
        modalKey: "excelDynamicReport",
        config: {
          title: "Withdrawal Report",
          fields: [
            {
              type: "dateRange",
              label: "Date Range*",
              name: "withdrawalDateRange"
            }
          ]
        }
      }
      ,
    ]
  }
],
"Form Submission Report": [
  {
    title: "Student Form Submission Report",
    description: "Displays a detailed record of submissions made by students, including dates and statuses",
    modalKey: "excelDynamicReport",
    config: {
      title: "Student Form Submission Report",
      fields: [
        {
          type: "dropdown",
          label: "Select Form Name",
          name: "formName",
          placeholder: "Select Form",
          options: [
            { label: "Select Form", value: "" }
          ]
        },
        {
          type: "dropdown",
          label: "Select Room",
          name: "room",
          placeholder: "All Rooms",
          options: [
            { label: "All Rooms", value: "" }
          ]
        }
      ]
    }
  }
  ,
  {
    title: "Staff Form Submission Report",
    description: "Provides a comprehensive record of submissions made by staff members, including submission dates and statuses",
    modalKey: "excelDynamicReport",
    config: {
      title: "Staff Form Submission Report",
      fields: [
        {
          type: "dropdown",
          label: "Select Form Name",
          name: "formName",
          placeholder: "Select Form",
          options: [
            { label: "Select Form", value: "" }
          ]
        },
        {
          type: "dropdown",
          label: "Select Room",
          name: "room",
          placeholder: "All Rooms",
          options: [
            { label: "All Rooms", value: "" }
          ]
        }
      ]
    }
  }
  
],
"Activity Report": [
  {
  title: "Activity Excel Report",
  description: "Generate excel of the activities posted under a date range",
  modalKey: "excelDynamicReport",
  config: {
    title: "Activity Excel Report",
    fields: [
      {
        type: "dropdown",
        label: "Select Form Name",
        name: "formName",
        placeholder: "Select Form",
        options: [
          { label: "Select Form", value: "" }
        ]
      },
      {
        type: "dropdown",
        label: "Select Room",
        name: "room",
        placeholder: "All Rooms",
        options: [
          { label: "All Rooms", value: "" }
        ]
      }
    ]
  }
}

],




  };
  
  export default ReportsData;
  